import {
  Button,
  TextField,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { prettify } from "../../../utils/utils";
import { useGetDevices } from "../useDeviceQueries";
import { useState } from "react";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { useGetServiceById, usePutServiceById } from "../../ServiceComponents";
import { usePutDeviceById } from "../useDeviceQueries";

function LinkDevice({ patient_id, service_id, closeModal }) {
  // === web service queries/mutations ===
  const linkMutation = usePutDeviceById(null, closeModal);
  const devicesQuery = useGetDevices("all"); // SOLO QUELLI CON INSTALLED=FALSE
  const serviceQuery = useGetServiceById(service_id);
  const updateServiceMutation = usePutServiceById();

  const handleLinkDevice = () => {
    // aggiorna il dispositivo associandoci il paziente
    linkMutation.mutate({
      id: device_id,
      patient_id,
      is_installed: true,
    });

    // aggiorna il servizio mettendolo attivo
    updateServiceMutation.mutate({
      id: service_id,
      cr_activation: true,
    });

    closeModal();
  };

  const handleChange = (e) => {
    setDevice_id(e.target.value);
  };

  const [device_id, setDevice_id] = useState("");
  if (
    devicesQuery.isLoading ||
    devicesQuery.isIdle ||
    serviceQuery.isLoading ||
    serviceQuery.isIdle
  )
    return <LoadingPaper />;
  if (devicesQuery.isError || serviceQuery.isError)
    return <LoadingError error={devicesQuery.error} />;

  return (
    <>
      <DialogTitle>Dispositivi disponibili</DialogTitle>
      <DialogContent>
        {devicesQuery.data.devices.length === 0 ||
        devicesQuery.data.devices.filter((el) => el.patient_id === null)
          .length === 0 ? (
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            id="device_id"
            name="device_id"
            label="Dispositivo"
            type="text"
            disabled={true}
            variant="standard"
            value={"Nessun dispositivo disponibile"}
          />
        ) : (
          <TextField
            autoFocus
            select
            margin="dense"
            fullWidth
            id="device_id"
            name="device_id"
            label="Dispositivo"
            type="text"
            variant="standard"
            onChange={handleChange}
            value={device_id}
          >
            {devicesQuery.data.devices.map(
              (option) =>
                option.patient_id === null && (
                  <MenuItem key={option.id} value={option.id}>
                    {prettify(option.name)}
                  </MenuItem>
                )
            )}
          </TextField>
        )}

        <TextField
          margin="dense"
          fullWidth
          disabled
          id="note"
          name="note"
          label="Note"
          multiline
          minRows={4}
          type="text"
          variant="standard"
          onChange={null}
          value={serviceQuery.data.note}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={false} onClick={handleLinkDevice}>
          Associa
        </Button>
        <Button disabled={false} color="error" onClick={closeModal}>
          Annulla
        </Button>
      </DialogActions>
    </>
  );
}

export default LinkDevice;
